import React from 'react';
const LongBackLine = React.memo((props) => {
    return (React.createElement("div", { className: "relative md:h-12 sm:h-10 h-8 flex items-center " },
        React.createElement("div", { className: "lg:text-2xl md:text-xl sm:text-base text-sm text-gray-400" },
            "\u00BB ",
            props.label,
            props.underbar ? "_" : ""),
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 846.35 29.31", className: "longbackline-animation absolute bottom-0 left-0 w-full" },
            React.createElement("polyline", { className: "longbackline", points: "0 28.81 817.54 28.81 846 0.35" }))));
});
export default LongBackLine;
